import { withAuthenticationRequired } from '@tom-ui/utils'
import {
  GeneralCargoOperatorContainer,
  GeneralCargoOperatorLandingContainer,
  useOperationsStore,
} from '@tom-ui/operations'
import { observer } from 'mobx-react-lite'
import { GeneralCargoWorkInstructionStepper } from './GeneralCargoWorkInstructionStepper'

export const GeneralCargoOperator = withAuthenticationRequired(
  observer(() => {
    const { equipmentOperatorWorkInstructionsUIStore } = useOperationsStore()

    return (
      <>
        {equipmentOperatorWorkInstructionsUIStore.isFulfilled ? (
          <>
            <GeneralCargoOperatorContainer />

            <GeneralCargoWorkInstructionStepper />
          </>
        ) : (
          <GeneralCargoOperatorLandingContainer />
        )}
      </>
    )
  }),
)
